// extracted by mini-css-extract-plugin
module.exports = {"Ricevute":"Ricevute__Ricevute__[hash_base64-5]","Title":"Ricevute__Title__[hash_base64-5]"};